import { useTypesStore } from "../store/Types.js";
import { useTypesRender } from "../utils/useRender.js";
export var Bigint = props => {
  var {
    Bigint: Comp = {}
  } = useTypesStore();
  useTypesRender(Comp, props, 'Bigint');
  return null;
};
Bigint.displayName = 'JVR.Bigint';